/* eslint-disable @typescript-eslint/no-redeclare */
import { Static, Type } from '@sinclair/typebox';

export type ScheduleIncrementObject = Static<typeof ScheduleIncrementObject>;
export const ScheduleIncrementObject = Type.Object({
  start: Type.Union([Type.Number(), Type.String()]),
  increment: Type.Number(),
});
